import React, { useState, useEffect } from 'react';
import LogLine from './LogLine';

function getKey(message) {
  const { data, date } = message || {};
  const [line] = data || [];
  if (typeof line !== 'string') {
    return `log-line-${date}`;
  }
  return `log-line-${date}-${line.substring(10)}`;
}

export default function LogReader() {
  const [log, setLog] = useState([]);
  if (window.ipc) {
    useEffect(() => {
      if (typeof window.ipc.on === 'function') {
        window.ipc.on('logStored', (event, storedLog) => setLog(storedLog));
      }
      return function cleanup() {
        if (typeof window.ipc.on === 'function') {
          window.ipc.removeAllListeners('logStored');
        }
      };
    }, []);
  }
  return (
    <table>
      <tbody>
        {
          (log || []).reverse().map((message) => (
            <LogLine key={getKey(message)} message={message} />
          ))
        }
      </tbody>
    </table>
  );
}
